import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Home from "pages/Home";
import History from "pages/History";
import Login from "pages/Login";
import NotFound from "pages/NotFound";

// PrivateRoute component
const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem("jwt"); // Get JWT from localStorage
  return token ? children : <Navigate to="/auth/login" replace />;
};

// PublicRoute component
const PublicRoute = ({ children }) => {
  const token = localStorage.getItem("jwt"); // Get JWT from localStorage
  return token ? <Navigate to="/" replace /> : children;
};

const RoutesMain = () => {
  return (
    <>
      <Routes>
        {/* Protected Routes */}
        <Route
          exact
          path="/"
          element={
            <PrivateRoute>
              <Home />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path="/history"
          element={
            <PrivateRoute>
              <History />
            </PrivateRoute>
          }
        />
        {/* Public Routes */}
        <Route
          exact
          path="/auth/login"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />
        <Route exact path="/not-found" element={<NotFound />} />
        {/* Fallback Route */}
        <Route path="*" element={<Navigate to="/not-found" />} />
      </Routes>
    </>
  );
};

export default RoutesMain;
